export default 'School not found - Click to contact USBC Collegiate'


// WEBPACK FOOTER //
// ./src/containers/event/EventWizard/Participants/Constants/schoolNotFound.js